import React, { useState, useEffect, Fragment } from 'react';
import { Transition } from '@headlessui/react';
import { FaTimes } from 'react-icons/fa';
import axios from '../../../services/api';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const AssignSipModal = ({ isOpen, onClose, publicService, onSuccess }) => {
  const { t } = useTranslation();
  const [unassignedSips, setUnassignedSips] = useState([]);
  const [selectedSip, setSelectedSip] = useState('');

  useEffect(() => {
    setSelectedSip('');
    if (isOpen) {
      fetchUnassignedSips();
    }
  }, [isOpen]);

  const fetchUnassignedSips = async () => {
    try {
      const response = await axios.get(`/settings/unassigned-sips?type=sip`);
      setUnassignedSips(response.data);
    } catch (error) {
      toast.error('Failed to fetch unassigned SIP accounts');
    }
  };

  const handleAssign = async () => {
    if (!selectedSip) {
      toast.error('Please select a SIP account');
      return;
    }

    try {
      await axios.post('/settings/assign-staff-sip', {
        publicServiceId: publicService._id,
        sipAccount: selectedSip
      });
      setSelectedSip('');
      toast.success(t('SIP account assigned successfully'));
      onSuccess();
      onClose();
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Transition appear show={isOpen} as={Fragment}>
      <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-[60]">
        <div className="bg-white w-[30vw] rounded-lg shadow-xl overflow-hidden">
          <div className="bg-black text-white flex justify-between items-center px-4 py-3 border-b">
            <h2 className="text-lg">{t('SIP Account Setting')}</h2>
            <button onClick={onClose}>
              <FaTimes />
            </button>
          </div>

          <div className="p-4">
            <div className="mb-4">
              <div className="text-sm mb-2">{t('Select one from unassigned SIP List')}</div>
              <select
                value={selectedSip}
                onChange={(e) => setSelectedSip(e.target.value)}
                className="w-full border rounded px-3 py-2"
              >
                <option value="">{t('Select SIP Account')}</option>
                {unassignedSips.map(sip => (
                  <option key={sip._id} value={sip.username}>
                    {sip.username}
                  </option>
                ))}
              </select>
            </div>
          </div>

          <div className="flex justify-end gap-2 px-4 py-3 border-t">
            <button
              onClick={onClose}
              className="px-4 py-2 text-gray-600 hover:bg-gray-100 rounded"
            >
              {t('Cancel')}
            </button>
            <button
              onClick={handleAssign}
              className="px-4 py-2 bg-blue-500 text-white rounded hover:bg-blue-600"
            >
              {t('Save')}
            </button>
          </div>
        </div>
      </div>
    </Transition>
  );
};

export default AssignSipModal;